'use client';

import { Loading } from '@/shared/components/Loading';
import { getSafeSameOriginRedirectUri } from '@/shared/utils/url';
import { signIn, signOut } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';

export const MagicLinkHandler = ({ authExchangeCode, redirectUrl = '/mypage' }: { authExchangeCode: string; redirectUrl?: string }) => {
  const router = useRouter();
  // 認証コードは1回しか交換できないので、StrictMode の二重実行や再レンダーで交換を繰り返さない
  const isStartedRef = useRef(false);

  useEffect(() => {
    const handleMagicLinkLogin = async () => {
      if (!authExchangeCode || isStartedRef.current) return;
      isStartedRef.current = true;
      const hash = typeof window !== 'undefined' ? window.location.hash : '';
      const base = getSafeSameOriginRedirectUri(redirectUrl, window.location.origin);
      const fallback = `/login?redirect_uri=${encodeURIComponent(base)}`;
      try {
        await signOut({ redirect: false }); // usedAtを更新するためにログアウトしてから再度ログイン処理を行う
        const res = await signIn('auth-exchange-code', { authExchangeCode, redirect: false });
        if (res?.error) {
          router.replace(fallback);
          return;
        }
        window.location.assign(`${base}${hash}`);
      } catch {
        router.replace(fallback);
      }
    };
    handleMagicLinkLogin();
  }, [authExchangeCode, redirectUrl, router]);

  return <Loading />;
};
